module.exports = __webpack_public_path__ + "img/porre_basic.d5c4f15a.jpg";